import React, { useState } from 'react'
import { Accordion, Card } from 'react-bootstrap'
import { useRouter } from 'next/router'
import { useAccordionToggle } from 'react-bootstrap'
import PropTypes from 'prop-types'
import classNames from 'classnames'

import styles from './AccordionContainer.module.scss'

const AccordionToggler = ({ children, eventKey, show, iconName }) => {
  const [status, setStatus] = useState(show)

  const decoratedOnClick = useAccordionToggle(eventKey, (eventKey) => {
    eventKey.preventDefault()
    setStatus(!status)
  })

  return (
    <a
      href=""
      className={classNames(
        'd-block',
        styles.customToggle,
        'sidebar-link',
        { show: status },
        { [styles.show]: status },
        iconName
      )}
      onClick={decoratedOnClick}
    >
      {children}
    </a>
  )
}

const AccordionContainer = ({ path, iconClassName, title, children }) => {
  const { pathname, asPath } = useRouter()

  const getPath = (urlPath) => {
    const paths = urlPath.split('/')
    const path = paths.pop()
    return path
  }

  const shouldShow = (pathname, path) => {
    if (typeof path === 'string') {
      return getPath(pathname) === getPath(path) || pathname.startsWith(path)
    } else if (Array.isArray(path)) {
      return path.some((p) => {
        return getPath(pathname) === getPath(p) || p === asPath
      })
    } else {
      console.warn(`Passed invalid path to AccordionContainer: ${path}.`)
      return true
    }
  }

  const show = shouldShow(pathname, path)

  return (
    <Accordion defaultActiveKey={show ? '0' : ''}>
      <Card>
        <Card.Header>
          <AccordionToggler eventKey="0" iconName={iconClassName} show={show}>
            {title}
          </AccordionToggler>
        </Card.Header>
        <Accordion.Collapse eventKey="0">
          <Card.Body>{children}</Card.Body>
        </Accordion.Collapse>
      </Card>
    </Accordion>
  )
}

AccordionContainer.propTypes = {
  path: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]),
  title: PropTypes.string.isRequired,
  iconClassName: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired
}

AccordionToggler.defaultProps = {
  show: false
}

AccordionToggler.propTypes = {
  show: PropTypes.bool,
  iconName: PropTypes.string.isRequired,
  eventKey: PropTypes.string,
  children: PropTypes.node.isRequired
}

export default AccordionContainer
